export const fmtPct = (n: number) => {
  const rounded = Math.round(n * 100) / 100;
  const sign = n >= 0 ? "+" : "-";
  return `${sign}${Math.abs(rounded).toFixed(2)}%`;
};
export const fmtUsd = (n: number) => `$${n.toFixed(2)}`;
export const fmtTime = (epoch: number, tz = "Asia/Shanghai") =>
  new Intl.DateTimeFormat("zh-CN", { timeZone: tz, hour12: false, month: "2-digit", day: "2-digit", hour: "2-digit", minute: "2-digit", second: "2-digit" }).format(new Date(epoch * 1000));
export const levelColor = (level: string) =>
  ({ strong: "#B91C1C", signal: "#E53935", watch: "#EAB308" } as Record<string, string>)[level] ?? "#666666";
export const connectionLabel = (latestTs: number, now: number) => (now - latestTs <= 10 ? "LIVE" : "STALE");

/** Percentile rank of `v` within `sortedAsc` (ascending): % of values <= v, in [0,100]. */
export function percentile(sortedAsc: number[], v: number): number {
  const n = sortedAsc.length;
  if (n === 0) return NaN;
  let lo = 0, hi = n;
  while (lo < hi) {
    const mid = (lo + hi) >> 1;
    if (sortedAsc[mid] <= v) lo = mid + 1;
    else hi = mid;
  }
  return (lo / n) * 100; // lo = count of values <= v
}

/** Insert `v` into an ascending array, keeping it sorted. */
export function sortedInsert(sortedAsc: number[], v: number): void {
  let lo = 0, hi = sortedAsc.length;
  while (lo < hi) {
    const mid = (lo + hi) >> 1;
    if (sortedAsc[mid] <= v) lo = mid + 1;
    else hi = mid;
  }
  sortedAsc.splice(lo, 0, v);
}
